import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'

// Menu item links are followed by Unpoly (`a[href]` is a global followSelector), which halts
// the underlying click event before it can bubble to an ancestor listener. `up:link:follow` is
// Unpoly's own event and fires regardless, so we track menu items through it, like track_links.ts does.
up.on('click', '#subject-area-switches [data-dropdown-toggle]', (_event, toggle: HTMLElement) => {
  trackElementInteraction(toggle, 'click.headerNavigationSplit')
})

up.on('up:link:follow', '#subject-area-switches a', (_event, link: HTMLAnchorElement) => {
  trackElementInteraction(link, 'click.headerNavigationSplit')
})
